module.exports = __webpack_public_path__ + "static/media/f_hairstyle_frizzy_medium_front_vector.3449ea77.svg";